import React from 'react';
import { Link } from 'react-router-dom';

const Breadcrumbs = ({ items }) => {
  return (
    <nav style={{
      padding: '15px 0',
      fontSize: '14px',
      color: '#999'
    }}>
      {items.map((item, index) => (
        <span key={index}>
          {index > 0 && <span style={{ margin: '0 8px' }}>/</span>}
          {item.link ? (
            <Link to={item.link} style={{
              color: '#00bfff',
              textDecoration: 'none',
              transition: 'color 0.2s'
            }}>
              {item.label}
            </Link>
          ) : (
            <span style={{ color: '#fff' }}>{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
